export const SIDEBAR_DEFAULT_WIDTH = 246;
export const MOBILE_BREAKPOINT = 540;
export const APP_SIDEBAR_OPEN = 'app-sidebar-open';
